import axios from 'axios';
import { config } from '../../../../config/envs';

const BASE_URL = process.env.REACT_APP_API_URL;
const ADMIN_BASE_URL = config.app.adminBaseUrl;

export class OfferAPI {
  static async create(payload) {
    const response = await axios.post(`${BASE_URL}/payment-link/create`, payload);
    if (!response.data.success)
      throw new Error(response.data.message || 'Erro ao criar link de pagamento');
    return response.data;
  }

  static async createV2(payload) {
    const response = await axios.post(`${ADMIN_BASE_URL}/v2/payment-link/create`, payload);
    if (!response.data.success)
      throw new Error(response.data.message || 'Erro ao criar link de pagamento');
    return response.data;
  }

  static async getV2(id) {
    const response = await axios.get(`${ADMIN_BASE_URL}/v2/payment-link/${id}`);
    return response.data;
  }

  static async updateV2(id, payload) {
    const response = await axios.put(
      `${ADMIN_BASE_URL}/v2/payment-link/${id}`,
      payload,
    );
    if (!response.data.success)
      throw new Error(response.data.message || 'Erro ao atualizar link de pagamento');
    return response.data;
  }

  static async getActive(clientId) {
    const response = await axios.get(`${BASE_URL}/payment-link/active/${clientId}`);
    return response.data;
  }

  static async getActiveV2(clientId) {
    const response = await axios.get(
      `${ADMIN_BASE_URL}/v2/payment-link/active/${clientId}`,
    );
    return response.data;
  }

  static async list({ page, pageSize, activeOnly, search } = {}) {
    const response = await axios.get(
      `${ADMIN_BASE_URL}/v2/payment-link`,
      { params: { page, pageSize, activeOnly, search: search || undefined } },
    );
    return response.data;
  }

  static async listPaymentMethods() {
    const response = await axios.get(
      `${ADMIN_BASE_URL}/v2/payment-link/payment-methods`,
    );
    return response.data;
  }

  static async sendEmail(codeLink, email, url) {
    const response = await axios.post(
      `${BASE_URL}/payment-link/send-email/${codeLink}`,
      { email, url },
    );
    if (!response.data.success) throw new Error('Erro ao enviar email');
    return response.data;
  }

  static async sendEmailV2(codeLink, name, email, url) {
    const response = await axios.post(
      `${ADMIN_BASE_URL}/v2/payment-link/send-email/${codeLink}`,
      { name, email, url },
    );
    if (!response.data.success) throw new Error('Erro ao enviar email');
    return response.data;
  }

  static async expire(codeLink) {
    const response = await axios.put(`${BASE_URL}/payment-link/expire/${codeLink}`);
    if (!response.data.success) throw new Error('Erro ao expirar link');
    return response.data;
  }

  static async expireV2(codeLink) {
    const response = await axios.put(
      `${ADMIN_BASE_URL}/v2/payment-link/expire/${codeLink}`,
    );
    if (!response.data.success) throw new Error('Erro ao expirar link');
    return response.data;
  }
}
